import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=282a2b52"
var script = {}
import style0 from "./Main.vue?vue&type=style&index=0&id=282a2b52&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports